import styled from "styled-components";

export const LabelErrorContainer = styled("div")`
   margin-top: 19px;
   text-align: center;
`;
